/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import moment from 'moment-timezone';
import { Carservice, CarserviceFamily } from 'rest-client';

import { VehicleData } from '@shared/models/vehicle-data.model';

import { VEHICLE_KM_FORMAT } from '../const/date-picker.consts';

export interface RequestedCarServicesData {
  umc: boolean;
  bodyCode: boolean;
  motorCode: boolean;
  km: boolean;
  allNeedsUmc: boolean;
}

export function checkVehicleStatus(
  carServicesFamily: CarserviceFamily,
  requestedVehicleData: VehicleData
): boolean {
  const requestedCSData = createRequestedCarServiceData(carServicesFamily);
  if (!requestedVehicleData.id && requestedCSData.allNeedsUmc) {
    return false;
  } else if (
    requestedCSData.bodyCode &&
    !requestedVehicleData.bodyCode &&
    requestedCSData.allNeedsUmc
  ) {
    return false;
  } else if (
    requestedCSData.motorCode &&
    !requestedVehicleData.motorCode &&
    requestedCSData.allNeedsUmc
  ) {
    return false;
  } else if (
    (requestedCSData.km &&
      !requestedVehicleData.km &&
      requestedCSData.allNeedsUmc) ||
    (requestedCSData.km &&
      !isToday(requestedVehicleData.kmTimestamp) &&
      requestedCSData.allNeedsUmc)
  ) {
    return false;
  }

  return true;
}

export function checkVehicleStatusFromCarService(
  carService: Carservice,
  requestedVehicleData: VehicleData
): boolean {
  const requestedCSData = createRequestedCarServiceDataFromCarService(
    carService
  );
  if (!requestedVehicleData.id && requestedCSData.allNeedsUmc) {
    return false;
  } else if (
    requestedCSData.bodyCode &&
    !requestedVehicleData.bodyCode &&
    requestedCSData.allNeedsUmc
  ) {
    return false;
  } else if (
    requestedCSData.motorCode &&
    !requestedVehicleData.motorCode &&
    requestedCSData.allNeedsUmc
  ) {
    return false;
  } else if (
    (requestedCSData.km &&
      !requestedVehicleData.km &&
      requestedCSData.allNeedsUmc) ||
    (requestedCSData.km &&
      !isToday(requestedVehicleData.kmTimestamp) &&
      requestedCSData.allNeedsUmc)
  ) {
    return false;
  }

  return true;
}

export const isToday = (date: Date | string): boolean => {
  const momentDate = moment(date, VEHICLE_KM_FORMAT);
  const timestamp = momentDate.toDate();
  const today = new Date();
  return (
    timestamp.getDate() === today.getDate() &&
    timestamp.getMonth() === today.getMonth() &&
    timestamp.getFullYear() === today.getFullYear()
  );
};

//TODO: Translate this function to RESTClient CarServiceFamily Builder

export function createRequestedCarServiceData(
  carServicesFamily: CarserviceFamily
): RequestedCarServicesData {
  const carServices = carServicesFamily?.car_services
    ? carServicesFamily.car_services
    : [];
  const requestedCSData: RequestedCarServicesData = {} as RequestedCarServicesData;
  const requestedUmcArray: Array<boolean> = [],
    resquestedBodyCodeArray: Array<boolean> = [],
    requestedMotorCodeArray: Array<boolean> = [],
    requestedKmCodeArray: Array<boolean> = [];
  let allNeedsUmc = true;

  carServices.forEach((carService: Carservice) => {
    requestedUmcArray.push(!!+carService.umc_required);
    if (!!!+carService.umc_required) {
      allNeedsUmc = false;
    }
    resquestedBodyCodeArray.push(
      !!Number(carService.body_applicabilitycode_required)
    );
    requestedMotorCodeArray.push(
      !!+carService.motor_applicabilitycode_required
    );
    requestedKmCodeArray.push(!!+carService.request_km);
  });

  requestedCSData.umc = checkBooleanArray(requestedUmcArray);
  requestedCSData.bodyCode = checkBooleanArray(resquestedBodyCodeArray);
  requestedCSData.motorCode = checkBooleanArray(requestedMotorCodeArray);
  requestedCSData.km = checkBooleanArray(requestedKmCodeArray);
  requestedCSData.allNeedsUmc = allNeedsUmc;

  return requestedCSData;
}

export function createRequestedCarServiceDataFromCarService(
  carService: Carservice
): RequestedCarServicesData {
  const carServices = [carService];
  const requestedCSData: RequestedCarServicesData = {} as RequestedCarServicesData;
  const requestedUmcArray: Array<boolean> = [],
    resquestedBodyCodeArray: Array<boolean> = [],
    requestedMotorCodeArray: Array<boolean> = [],
    requestedKmCodeArray: Array<boolean> = [];
  let allNeedsUmc = true;

  carServices.forEach((carService: Carservice) => {
    requestedUmcArray.push(!!+carService.umc_required);
    if (!!!+carService.umc_required) {
      allNeedsUmc = false;
    }
    resquestedBodyCodeArray.push(
      !!Number(carService.body_applicabilitycode_required)
    );
    requestedMotorCodeArray.push(
      !!+carService.motor_applicabilitycode_required
    );
    requestedKmCodeArray.push(!!+carService.request_km);
  });

  requestedCSData.umc = checkBooleanArray(requestedUmcArray);
  requestedCSData.bodyCode = checkBooleanArray(resquestedBodyCodeArray);
  requestedCSData.motorCode = checkBooleanArray(requestedMotorCodeArray);
  requestedCSData.km = checkBooleanArray(requestedKmCodeArray);
  requestedCSData.allNeedsUmc = allNeedsUmc;

  return requestedCSData;
}

function checkBooleanArray(array: Array<boolean>): boolean {
  return !array.every((v: boolean) => v === false);
}
